// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"18":"7b879c30","215":"da550fde","872":"6a3f49f7"}[chunkId] + ".js";
};